import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useSize } from './useSize';
import { useDraggable } from './useDraggable';
import { useConfigContext } from '../config';
var typeDefs = {
  mode: String,
  firstSize: String,
  lastSize: String,
  min: [String, Number],
  max: [String, Number]
};
var defaults = function defaults() {
  return {
    mode: 'horizontal',
    firstSize: 'auto',
    lastSize: 'auto',
    min: 0,
    max: '100%-6'
  };
};
var events = {
  moveStart: true,
  moving: true,
  moveEnd: true
};
export var Split = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Split, _Component);
  function Split() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.size = useSize();
    _this.drag = useDraggable(_this.size.firstSize, _this.size.lastSize);
    _this.config = useConfigContext();
    return _this;
  }
  return Split;
}(Component);
Split.template = template;
Split.typeDefs = typeDefs;
Split.defaults = defaults;
Split.events = events;